<template>
  <div id="application_ready_outer"  v-if="applicationData != null && user != null" >
    <div style="text-align:center; color: #fc1a34;margin-bottom: 15px;" v-if="errorMsg != null">
      <span>{{errorMsg}}</span>
    </div>
    <div>
      <div class="input-row">
        <div class="column">*姓名：</div>
        <div class="column">
          <el-input v-model="applicationData.name" placeholder="请输入姓名" @change="valueChanged" :disabled="user.isIdentification > 0 && user.name != null && user.name.length > 0" />
        </div>
      </div>

      <div class="input-row">
        <div class="column">*身份证号码：</div>
        <div class="column">
<!--          <el-input v-model="applicationData.idNumber" placeholder="请输入您的身份证号" @change="valueChanged" clearable/>-->
          <el-input v-model="applicationData.idNumber" placeholder="请输入您的身份证号" :disabled="user.isIdentification > 0 && user.idNumber != null && user.idNumber.length > 0" @change="valueChanged" clearable/>
        </div>
      </div>

      <div class="input-row">
        <div class="column">*所属区域：</div>
        <div class="column">
          <el-select  placeholder="请选择所属区域" v-model="applicationData.area" @change="valueChanged" >
            <el-option
              v-for="(item, index) in areaList"
              :key="'area_select_' + index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div>


      <div class="input-row">
        <div class="column">籍贯：</div>
        <div class="column">
          <el-input v-model="applicationData.nativePlace" placeholder="请输入您的户籍地" clearable @change="valueChanged" />
        </div>
      </div>

      <div class="input-row">
        <div class="column">*学历：</div>
        <div class="column">
          <el-select  placeholder="请选择您的学历" v-model="applicationData.education" @change="valueChanged" >
            <el-option
              v-for="(item, index) in educationList"
              :key="'education_select_' + index"
              :label="item"
              :value="item"
            />
          </el-select>

        </div>
      </div>

      <div class="input-row">
        <div class="column">政治面貌：</div>
        <div class="column">
          <el-input v-model="applicationData.political" placeholder="请输入您的政治面貌" clearable @change="valueChanged" />
        </div>
      </div>

      <div class="input-row">
        <div class="column">*所在单位：</div>
        <div class="column">
          <el-input v-model="applicationData.affiliation" placeholder="请输入您的所在单位" clearable @change="valueChanged" />
        </div>
      </div>

      <div class="input-row">
        <div class="column">职务：</div>
        <div class="column">
          <el-input v-model="applicationData.title" placeholder="请输入您的职务" clearable @change="valueChanged"/>
        </div>
      </div>

      <div class="input-row">
        <div class="column">联系地址：</div>
        <div class="column">
          <el-input v-model="applicationData.addr" placeholder="请输入您的联系地址" clearable @change="valueChanged"/>

        </div>
      </div>

      <div class="input-row">
        <div class="column">*邮箱：</div>
        <div class="column">
          <el-input v-model="applicationData.email" placeholder="请输入您的邮箱" clearable @change="valueChanged" />
        </div>
      </div>

      <div class="input-row">
        <div class="column">体育行业经历：</div>
        <div class="column">
          <el-input v-model="applicationData.experience"
                    type="textarea"
                    :autosize="{minRows: 5, maxRows: 15}"
                    placeholder="请输入您的从业经历" @change="valueChanged"/>
        </div>
      </div>

      <div class="input-row">
        <div class="column">*联系人电话：</div>
        <div class="column">
          <el-input v-model="applicationData.tel" placeholder="请输入您的联系电话" clearable @change="valueChanged">
            <template slot="append">
              <el-button v-if="codeTimeValue == 0" class="input-right-button-able" @click="codeButtonClicked">获取验证码</el-button>
              <el-button v-else class="input-right-button-disable" disabled>{{codeTimeValue}}s重新获取</el-button>
            </template>
          </el-input>
        </div>
      </div>
      <div class="input-row">
        <div class="column">*短信验证码：</div>
        <div class="column" >
          <el-input v-model="verifyCode" placeholder="请输入手机验证码" clearable @change="valueChanged"/>
        </div>
      </div>
    </div>

    <div id="apply_check" >
        <el-checkbox v-model="isChecked">本人自愿加入&nbsp;"上海市篮球协会"&nbsp;成为个人会员，遵守<a href="https://img.shslqxh.com/上海市篮球协会章程202010.pdf" target="_blank">《上海市篮球协会章程》</a>，参加协会各项活动。</el-checkbox>
    </div>

    <div class="input-row" style="justify-content: center;margin-top: 30px;" v-if="applicationData.visa.length > 0">
      <img :src="applicationData.visa" style="max-width: 100%;height: auto;border: solid 1px #eee;">
    </div>

    <div class="input-row" style="justify-content: center;margin-top: 20px;">
      <el-button type="primary" style="min-width: 150px;background-color: rgb(62,85,250);" @click="signatureButtonClicked" >{{applicationData.visa != '' ? '重新签名' : '签名'}}</el-button>
    </div>

    <div class="input-row" style="flex-wrap: nowrap;justify-content: center;margin-top: 30px;">
<!--        <el-button style="width: 120px;color: #666;" @click="cancelButtonClicked" round>取消</el-button>-->
        <el-button style="background-color: #fc1a34;border-color: #fc1a34;width: 50%;max-width: 200px;" @click="submitButtonClicked" type="primary" round>下一步</el-button>
    </div>

    <my-signature v-if="showSignatureVue"
                  @success="signatureSuccess"
                  @close="showSignatureVue = false" ></my-signature>

  </div>
</template>

<script>
  import MySignature from "../../common/MySignature";
  import EventManager from '../../../js/event-common';
export default {
  name: "ApplicationReady",
  components: {
    MySignature
  },
  data() {
    return {
      headers: {},
      codeTimeValue: 0,
      codeTimerFlag: null,
      errorMsg: null,
      isEdited: false,

      areaList: [
        '黄浦区',
        '静安区',
        '长宁区',
        '普陀区',
        '虹口区',
        '杨浦区',
        '浦东新区',
        '闵行区',
        '徐汇区',
        '宝山区',
        '嘉定区',
        '金山区',
        '松江区',
        '青浦区',
        '奉贤区',
        '崇明区',
        '学生体协',
        '上海体院',
        '其他行业体协'
      ],

      educationList: [
        '小学',
        '初级中学',
        '高级中学',
        '大学专科',
        '大学本科',
        '硕士研究生',
        '博士研究生',
        '其他'
      ],


      initialData: {
        name: '',
        area: '',
        nativePlace: '',
        education: '',
        idNumber: '',
        political: '',
        affiliation: '',
        title: '',
        tel: '',
        addr: '',
        experience: '',
        visa: '',
        email: '',
      },

      applicationData: null,
      verifyCode: '',
      isChecked: false,
      showSignatureVue: false,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    user() {
      return this.$store.state.user;
    }
  },
  destroyed() {
    this.closeCodeTime();
  },
  mounted() {
    let token = this.$store.state.dataStore.getToken();
    this.headers.token = token;
    this.initApplicationData();
  },
  methods: {

    configErrorMsg() {
      let idErrorRemark = this.$store.state.idErrorRemark;
      if (idErrorRemark != null) {
        this.errorMsg = idErrorRemark;
        this.$store.commit('setIdErrorRemark', null);
      } else {
        let user = this.user;
        let auditRemark = user.auditRemark;
        let status = user.status;
        if (status == 4 && auditRemark != null && auditRemark != '') {
          this.errorMsg = auditRemark;
        }
      }
    },

    initApplicationData() {
      let user = this.user;
      if (user == null) {
        let _this = this;
        setTimeout(function () {
          _this.initApplicationData();
        },50);
        return;
      }

      console.log(user);
      let applicationData = {};
      for (let key in this.initialData) {
        let value = user[key];
        if (value == undefined || value == null) {
          value = this.initialData[key];
        }
        this.initialData[key] = value;
        applicationData[key] = value;
      }
      this.applicationData = applicationData;
      this.configErrorMsg();
    },

    valueChanged() {
      let isEdit = false;
      for (let key in this.initialData) {
        let initialValue = this.initialData[key];
        let value = initialValue;

        if (key == 'name' || key == 'experience') {
          let value = this.applicationData[key].removeNamesBlank();
        } else {
          value = this.applicationData[key];
          if (typeof value == 'string') {
            value = value.removeBlanks();
          }
        }
        if (value != initialValue) {
          isEdit = true;
          break
        }
      }
      let storedEditing = !this.$store.state.allowedLeave;
      this.isEdited = isEdit;
      if (storedEditing != isEdit) {
        this.$store.commit('isAllowedLeave', !isEdit);
      }
    },

    codeButtonClicked() {
      if (this.codeTimeValue > 0) {
        return;
      }

      let phoneNumbers = this.applicationData.tel.removeBlanks();
      if (phoneNumbers == '') {
        this.$toast('请输入联系人电话！');
        return;
      }

      if (!phoneNumbers.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }
      let params = {
        tag: 'member',
        phoneNumbers
      };
      let _this = this;
      this.httpManager.ajax.smsSend(params, function (data) {
        if (data.code == 0) {
          _this.beginCodeTime();
        }
      }, function (data) {
        _this.$toast('请求失败，请重试！');

      });
    },

    beginCodeTime() {
      this.codeTimeValue = 60;

      let _this = this;
      this.codeTimerFlag = setInterval(function () {
        _this.codeTimeValue --;
        if (_this.codeTimeValue <= 0) {
          _this.closeCodeTime();
        }
      }, 1000);
    },
    closeCodeTime() {
      if (this.codeTimerFlag != null) {
        clearInterval(this.codeTimerFlag);
        this.codeTimerFlag = null;
      }
    },

    cancelButtonClicked() {
      EventManager.postNotification(EventManager.notificationNameObject.VipApplyCancel);
    },

    generateNewUser(params) {
      let user = this.user;
      for (let key in params) {
        user[key] = params[key];
      }
      return user;
    },

    submitButtonClicked() {
      let params = {};
      let name = this.applicationData.name.removeBlanks();
      if (name == '') {
        this.$toast('请输入您的姓名！');
        return;
      }
      params.name = name;

      let idNumber = this.applicationData.idNumber.removeBlanks();
      if (idNumber == '') {
        this.$toast('请输入您的身份证号！');
        return;
      }

      if (idNumber.length < 18 || !idNumber.isIdCard()) {
        this.showToast("请输入正确的二代身份证号码！");
        return;
      }

      params.idNumber = idNumber;
      let sex = idNumber.getSexFromIdCard();
      params.sex = sex == '男' ? 1 : 0;

      let area = this.applicationData.area.removeBlanks();
      if (area == '') {
        this.$toast('请选择所属区域！');
        return;
      }
      params.area = area;

      let nativePlace = this.applicationData.nativePlace.removeBlanks();
      params.nativePlace = nativePlace;

      let education = this.applicationData.education.removeBlanks();
      if (education == '') {
        this.$toast('请选择您的学历！');
        return;
      }
      params.education = education;

      let political = this.applicationData.political.removeBlanks();
      params.political = political;

      let affiliation = this.applicationData.affiliation.removeBlanks();
      if (affiliation == '') {
        this.$toast('请输入所在单位！');
        return;
      }
      params.affiliation = affiliation;

      let title = this.applicationData.title.removeBlanks();
      params.title = title;

      let addr = this.applicationData.addr.removeBlanks();
      params.addr = addr;

      let email = this.applicationData.email.removeBlanks();
      if (email == '') {
        this.$toast('请输入邮箱！');
        return;
      }
      params.email = email;

      let tel = this.applicationData.tel.removeBlanks();
      if (tel == '') {
        this.$toast('请输入联系人电话！');
        return;
      }
      params.tel = tel;

      let verifyCode = this.verifyCode.removeBlanks();
      if (verifyCode == '') {
        this.$toast('请输入短信验证码！');
        return;
      }
      params.verificationCode = verifyCode;

      let experience = this.applicationData.experience.removeBlanks();
      params.experience = experience;

      let visa = this.applicationData.visa;
      if (visa == '') {
        this.$toast('您尚未签名！');
        return;
      }
      params.visa = visa;

      let isChecked = this.isChecked;
      if (!isChecked) {
        this.$toast('您尚未勾选会员协议！');
        return;
      }

      params.flag = 6;
      this.postUserInforUpdateRequest(params);

    },

    isNameOrIdNumberChanged(params) {
      let name = params.name;
      let idNumber = params.idNumber;
      let initialData = this.initialData;
      let initialName = initialData.name;
      let initialIdNumber = initialData.idNumber;
      return (name != initialName || idNumber != initialIdNumber);
    },

    postUserInforUpdateRequest(params) {
      let user = this.user;
      let modified = user.modified;
      if (modified == 0 || modified == null) {
        modified = this.isEdited ? 1 : 0;
      }
      let isIdentification = user.isIdentification;
      let memberValidDate = user.memberValidDate;
      let auditStatus = user.auditStatus;
      let status = this.user.status;

      // if (isIdentification > 0) {
      //   if (this.isNameOrIdNumberChanged(params)) {
      //     isIdentification = 0;
      //   }
      // }

      if (isIdentification > 0) { // 身份已认证
        if (memberValidDate == null) { // 不是会员
          status = 1; // 到协会审核
        } else { // 会员已过期
          if (modified > 0) { // 数据已修改，到协会审核
            status = 1;
          } else { // 数据未修改, 到支付页面
            status = 2;
          }
        }
      } else { // 身份未认证
        status = 8;
      }

      params.status = status;
      params.modified = modified;
      params.auditStatus = 1;
      let _this = this;
      console.log(params);
      // return;
      this.httpManager.ajax.ucProfileUpdate(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.$toast('提交成功！');
          // user.status = 1;
          // _this.$store.commit('setUser', user);
          _this.$emit('submitSuccess');
          _this.$store.commit("isAllowedLeave", true);
          return;
        }
      }, function (data) {

      });
    },

    signatureButtonClicked() {
      this.showSignatureVue = true;
    },
    signatureSuccess(result) {
      let signatureUrl = result.signatureUrl;
      this.applicationData.visa = signatureUrl;
      this.showSignatureVue = false;
      console.log('---1');
      this.valueChanged();
    }
  }
}
</script>

<style scoped>
  #application_ready_outer {
    padding: 15px 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #application_ready_outer > div {
    width: 100%;
  }

  #application_ready_outer .input-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 15px;
  }

  #application_ready_outer .input-row:last-child {
    margin-bottom: 0;
  }

  #application_ready_outer .input-row > .column:first-child {
    width: 30%;
    text-align: right;
    padding-right: 15px;
  }

  #application_ready_outer .input-row > .column:not(:first-child) {
    width: 70%;
  }


  @media screen and (min-width: 768px) {
    .app-item {
      padding-left: 5%;
      padding-right: 5%;
      justify-content: flex-end;
    }

    .app-item > div:first-child {
      text-align: right;
      width: auto;
      margin-top: 30px;
    }

  }

  #application_ready_outer /deep/ .el-input__inner:focus, #application_ready_outer /deep/ .el-textarea__inner:focus {
    border: solid 1px #fc1a34;
  }


  #application_ready_outer /deep/ .is-checked .el-radio__inner {
    background-color: #fc1a34;
    border: solid 1px #fc1a34;
  }

  #application_ready_outer /deep/ .is-checked .el-radio__label {
    /*color: #fc1a34;*/
    color: #333;
  }

  #application_ready_outer /deep/ .el-radio__inner:hover {
    border: solid 1px #fc1a34;
  }


  .avatar-uploader {
    width: 150px;
    height: 150px;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .avatar-uploader img {
    width: 100%;
    height: auto;
    margin: auto;
  }

  .avatar-uploader i {
    color: #eee;
    font-size: 3rem;
    /*width: 100%;*/
    /*height: 100%;*/
  }


  .avatar-uploader .el-icon-camera {
    width: 150px;
    height: 150px;
    line-height: 150px;
    vertical-align: middle;
  }

  .avatar-uploader /deep/ input[type='file'] {
    display: none;

  }

  .upload-files {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .upload-files /deep/ input[type='file'] {
    display: none;

  }

  .code-button {
    margin-left: 15px;
    font-size: 1rem;

    width: 100px;
  }

  .bottom-notice-check {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }

  .bottom-notice-check /deep/ .el-checkbox__label {
    white-space: pre-wrap;
  }


  #application_ready_outer /deep/.el-checkbox {
    /*display: inline-grid;*/
    white-space: pre-line;
    word-wrap: break-word;
    /*overflow: hidden;*/
    /*line-height: 20px;*/
    /*background-color: red;*/
  }

  #application_ready_outer  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #fc1a34;
    border-color: #fc1a34;
  }

  #application_ready_outer /deep/ .el-checkbox__inner:hover {
    border-color: #fc1a34;
  }
  #application_ready_outer  /deep/ .el-checkbox__input .el-checkbox__inner {
    border-color: #dcdfe6;
  }

  #application_ready_outer /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    /*color: #fc1a34;*/
    color: #333;
  }

  #application_ready_outer .avatar-uploader /deep/ .el-upload--picture-card:hover {
    border-color: #fc1a34;
  }

  #application_letter > div:first-child {
    color: #999;
  }

  #application_letter > div:first-child a {
    /*text-decoration: none;*/
    color: #fc1a34;
  }


  #application_letter .el-button {
    background-color: #fc1a34;
    border-color: #fc1a34;
    width: 30vw;
    max-width: 300px;
    min-width: 150px;
  }

  #application_cards_upload /deep/ .el-upload-list__item {
    max-width: 55vw;
  }

  #application_cards_upload /deep/ .el-upload-list__item-name:hover {
    color: #fc1a34;
  }

  #application_cards_upload .el-button--primary {
    background-color: #fc1a34;
  }

  #official_cards_upload {
    justify-content: space-around;
    text-align: justify;
  }

  #official_cards_upload /deep/ input {
    display: none;
  }

  #official_cards_upload /deep/ .el-upload-list--picture-card .el-upload-list__item-status-label {
    background-color: #fc1a34;
  }

  #official_cards_upload /deep/ .el-upload--picture-card:hover {
    border-color: #fc1a34;
  }

  #application_ready_outer #apply_check {
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    padding: 0 5px;
    margin-top: 30px;

  }

  #application_ready_outer #apply_check .el-checkbox {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }

  #application_ready_outer #apply_check .el-checkbox /deep/ .el-checkbox__label {
    white-space: pre-line;
    word-wrap: break-spaces;
    vertical-align: top;
    max-width: 97%;
  }

  #application_ready_outer .el-input-group__append .el-button {
    margin: -9px -20px;
    border-radius: 0;
  }


  #application_ready_outer .input-right-button-able {
    background-color: #fc1a34;
    color: white;
  }

  #application_ready_outer .input-right-button-disable {
    background-color: lightgrey;
    color: white;
  }

  #application_ready_outer .el-select {
    width: 100%;
  }

  @media screen and (min-width: 768px){
    #application_ready_outer #apply_check .el-checkbox /deep/ .el-checkbox__label {
      max-width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/personApplicationVues/ApplicationReady.vue